module.exports = __webpack_public_path__ + "static/img/newanli-17.3d9b7249.jpg";